import { TEXTBOX } from '@/components/ChartHolder.constants';
import DashboardWidget from './DashboardWidget';
import { TextAlign } from './TextboxRef';

class DashboardTextBoxWidget extends DashboardWidget {
  constructor(
    readonly value: Nullable<string>,
    readonly textAlign: TextAlign,
    key: string | number,
    x: number,
    y: number,
    width: number,
    height: number,
    unit = 1,
  ) {
    super(key, x, y, width, height, TEXTBOX, unit);
  }

  static create = (
    ...args: ConstructorParameters<typeof DashboardTextBoxWidget>
  ) => new DashboardTextBoxWidget(...args);

  static fromJson(w: AddUnderscorePrefix<DashboardTextBoxWidget>) {
    return new DashboardTextBoxWidget(
      w._value,
      w._textAlign,
      w._key,
      w._x,
      w._y,
      w._width,
      w._height,
      w._unit,
    );
  }

  static toJson = (
    w: DashboardTextBoxWidget,
  ): AddUnderscorePrefix<DashboardTextBoxWidget> => ({
    _value: w.value,
    _textAlign: w.textAlign,
    _key: w.key,
    _x: w.x,
    _y: w.y,
    _width: w.width,
    _height: w.height,
    _unit: w.unit,
    _displayType: TEXTBOX,
  });

  hasChangesMade(other: DashboardTextBoxWidget) {
    return other.value !== this.value || other.textAlign !== this.textAlign;
  }

  equals(w: DashboardTextBoxWidget): boolean {
    if (!w) {
      return false;
    }
    if (w === this) {
      return true;
    }
    return (
      w.key === this.key &&
      w.x === this.x &&
      w.y === this.y &&
      w.width === this.width &&
      w.height === this.height &&
      w.displayType === this.displayType &&
      w.value === this.value &&
      w.textAlign === this.textAlign
    );
  }
}

export default DashboardTextBoxWidget;
